export const makeDate = (serverTimestamp) => {
  if (!serverTimestamp) return null
  //return new Date(serverTimestamp.seconds * 1000).toString()
  return new Date(serverTimestamp.seconds * 1000).toLocaleDateString('en-us', { weekday: "long", year: "numeric", month: "short", day: "numeric" })
}
